import type { RegulationPack } from '../types';

export const REGULATION_PACK_ASSESSMENT_QUESTIONS: Partial<
  Record<RegulationPack, readonly string[]>
> = {
  low_voltage_2014_35_eu: ['withinLowVoltageDirectiveRange'],
  emc_2014_30_eu: ['emitsOrAffectedByElectromagneticDisturbance'],
  radio_equipment_2014_53_eu: ['intentionallyTransmitsOrReceivesRadioWaves'],
  ai_act_2024_1689: [
    'prohibitedPractice',
    'safetyComponent',
    'thirdPartyConformityRequired',
    'annexIIIUseCase',
    'significantRisk',
    'profiling',
    'interactsWithPeople',
  ],
  cra_2024_2847: [
    'hasDigitalElements',
    'hasDataConnection',
    'excludedProduct',
    'importantClassI',
    'importantClassII',
    'criticalProduct',
  ],
  personal_protective_equipment_2016_425: [
    'minimalRisk',
    'categoryII',
    'categoryIIIRisk',
    'singleUnitForIndividual',
  ],
  construction_products_2024_3110: [
    'constructionProduct',
    'harmonisedSpecificationIdentified',
    'article14Exemption',
    'avsSystem1Plus',
    'avsSystem1',
    'avsSystem2Plus',
    'avsSystem3Plus',
    'avsSystem3',
    'avsSystem4',
  ],
  toy_safety_2025_2509: [
    'designedForPlayUnder14',
    'excludedToyProduct',
    'fullHarmonisedStandardsCoverage',
    'physicalMechanicalHazards',
    'flammabilityHazards',
    'chemicalHazards',
    'electricalHazards',
    'hygieneHazards',
    'radioactivityHazards',
  ],
};
